//トップページ　キービジュアルスライダー
export function idxFunc() {
  let indexTop = $("#indexTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(indexTop){

    //FVアニメーション
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    wait(0)
    .then(() =>{
      $(".mainview").addClass('isShow');
      return wait(400)
    })
    .then(() => {
      $('.mainviewImg').addClass('isShow');
      return wait(400)
    })
    .then(() => {
      $('.mainviewTxtBox').addClass('isShow');
    })

    //ホバーで画像を切り替え
    let hoverCount = $(".servicesNav li").length;
    let isHoverEnabled = false;

    $(window).resize(function () {
      resizecheck = $('#responsibleCheck').width();
      enableHover();
    });

    function enableHover() {
      if (resizecheck == '1' && !isHoverEnabled) {
        for (let i = 0; hoverCount >= i; i++) {
          let hoverTarget = $(`.servicesNav li:nth-child(${i})`);
          let changeTarget = $("#changeBase");
          let changeImage = $(`#change0${i}`);
          const servicesBtn = $("#servicesBtn")
          hoverTarget.hover(
            function () {
              changeImage.css({
                opacity: "1",
              });
              servicesBtn.hide()
            },
            function () {
              changeImage.css({
                opacity: "0",
              });
              changeTarget.css({
                opacity: "1",
              });
              servicesBtn.show()
            }
          );
        }
        isHoverEnabled = true;
      } else if (resizecheck == '2' && isHoverEnabled) {
        $(".servicesNav li").off("mouseenter mouseleave");
        isHoverEnabled = false;
      }
    }
    enableHover();


    function indexCommonAnimeFunc() {
      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonTwoColumnTit').hasClass('isShow')) {
                $(this).find('.commonTwoColumnTit').addClass('isShow');
                $(this).find('.commonTwoColumnTxt').addClass('isShow');
                $(this).find('.moreBtn01').addClass('isShow');
              }
              if ($('.moreBtn02').length) {
                $(this).find('.moreBtn02').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }indexCommonAnimeFunc();

    $(window).on('load scroll', function () {
      indexCommonAnimeFunc();
    });
  }
}